<!--工作室成果-->
<template>
    <div class="content-container">
        <div class="studio-query-container">
            <div class="studio-topimg-container">
                <img class="img-100" src="../../assets/ms_title.png" alt>
            </div>
        </div>
        <div class="page-achieve-container" v-show="showMode==='page'">
            <div class="achieve-top-title">工作室成果</div>
            <div class="achieve-list-container">
                <div class="achieve-container" v-if="dataList&&dataList.length>0">
                    <div class="achieve-item" @click="viewAchievement(item)" v-for="item in dataList" :key="item">
                        <div class="achieve-cover">
                            <img class="img-100" :src="item.cover" alt />
                        </div>
                        <div class="achieve-title">{{item.title}}</div>
                        <div class="achieve-studio">{{item.groupName}}</div>
                    </div>
                </div>
                <data-empty v-if="dataList&&dataList.length===0" title="暂无成果"/>
            </div>
            <div class="page-container" v-if="dataList&&dataList.length>0">
                <pageTag :background="true"
                         :pageSizes="[8, 12, 16]"
                         v-show="total > 0"
                         :total="total"
                         v-model:page.sync="queryParams.pageNum"
                         v-model:limit.sync="queryParams.pageSize"
                         @pagination="pageAchievement" />
            </div>
        </div>
        <!--详情-->
        <div class="page-achieve-container" v-show="showMode==='detail'">
            <view-info :info-id="this.infoId" info-title="成果详情"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty";
import pageTag from "@/components/Pagination/page.vue";
import {pageStudioInfo} from "@/api/admin/studio"
import viewInfo from "@/components/studioDetail/viewInfo.vue";

export default {
    name:'studioAchievement',
    components:{viewInfo, pageTag, dataEmpty},
    props:{
        studioNature:{
            type: String,
            default:"2"
        },
        achieveMode:{
            type: String,
            default:"page"
        }
    },
    watch:{
        achieveMode(newValue,oldValue){
            this.showMode = newValue;
        },
    },
    mounted() {
        if (this.$store.state.params.jumpParams.infoId){
            console.log("传参了");
            this.infoId = this.$store.state.params.jumpParams.infoId;
            this.showMode = "detail"
            this.$emit('change-mode',this.showMode, '3');
        }
        this.pageAchievement();
    },
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            showMode:'page',
            queryParams: {
                pageNum: 1,
                pageSize: 8,
                type:3,
                groupNature:'2',
            },
            total: 0,
            pageCount:0,
            dataList: [],
            infoId:'',
        }
    },
    methods: {
        pageAchievement(){
            this.queryParams.groupNature = this.studioNature;
            pageStudioInfo(this.queryParams).then(res=>{
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        viewAchievement(item){
            this.showMode = this.detailMode;
            this.infoId = item.infoId;
            this.$emit('change-mode',this.showMode, '3');
        }
    }
}

</script>

<style scoped>
.content-container{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}
.studio-query-container{
    width: 100%;
    height: auto;
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
}
.studio-topimg-container{
    width: 100%;
    height: 160px;
    img{
        width: 100%;
        height: 100%;
    }
}
.page-achieve-container{
    width: 100%;
    height: auto;
    margin-top: 16px;
    padding-bottom: 10px;
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
}
.achieve-top-title{
    width: 98%;
    height: 36px;
    margin: auto;
    line-height: 36px;
    font-size: 16px;
    border-bottom: 2px solid #0d55a4;
    font-weight: bold;
    color: #0d55a4;
}
.achieve-list-container{
    width: 100%;
    height: 460px;
    margin: auto;
    overflow-x: hidden;
}
.achieve-container{
    width: 98%;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
}
.achieve-item{
    width: 25%!important;
    height: 230px;
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
}
.achieve-cover{
    width: 100%;
    height: 160px;
    img{
        width: 100%;
        height: 100%;
    }
}
.achieve-title{
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #333333;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.achieve-studio{
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #0d55a4;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    margin-bottom: 10px;
}
</style>